import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Home from "./pages/(home)";
import Ilustrations from "./components/Ilustrations/Ilustrations";
import Sobre from "./pages/sobre";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import VoadorPage from "./components/VoadorPage";
import { ModalProvider, useModal } from "./contexts/ModalContext";
import PhotosGallery from "./components/Photos/PhotosGallery";
import Cadernos from "./pages/cadernos";
import Projetos from "./pages/projetos";

function AppContent() {
  const location = useLocation();
  const { isModalOpen } = useModal();
  const isHomePage = location.pathname === "/";

  return (
    <>
      {/* só mostra NavBar se não for home e não tiver modal aberto */}
      {!isHomePage && !isModalOpen && <NavBar isOpaque={!isHomePage} />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/ilustracoes" element={<Ilustrations />} />
        <Route path="/fotos" element={<PhotosGallery />} />
        <Route path="/voadores/:name" element={<VoadorPage />} />
        <Route path="/sobre" element={<Sobre />} />
        <Route path="/cadernos" element={<Cadernos />} />
        <Route path="/projetos" element={<Projetos />} />
      </Routes>

      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <ModalProvider>
        <AppContent />
      </ModalProvider>
    </Router>
  );
}

export default App;
